import MediaVaultView from './media-vault-view'
import PostView from './post-view'

export default {
    MediaVaultView,
    PostView,
}
